import React, { useEffect, useState } from 'react';
import PageLabel from './PageLabel';
import OrderForm from './OrderForm';
import RideInSearch from "./RideInSearch";
import RideInProgress from "./RideInProgress";
import ErrorModal from "./Modal/ErrorModal";
import Loader from "./Loader";
import backendApi from '../services/backendApi';

function Order() {
    const [rideInSearch, setRideInSearch] = useState(false);
    const [rideInProgress, setRideInProgress] = useState(false);
    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkActiveRide = async () => {
            try {
                const response = await backendApi.get('/api/get-active-ride');
                const data = response.data;

                setRideInSearch(data.searching);

                if (data.searching) {
                    setRideInProgress(false);
                }

                if (data.activeOrder) {
                    setRideInProgress(true);
                    setOrder(data.activeOrder);
                } else {
                    setRideInProgress(false);
                    setOrder(null);
                }
            } catch (error) {
                console.error('Failed to fetch active ride status:', error);
            } finally {
                setLoading(false);
            }
        };

        checkActiveRide();
        const interval = setInterval(checkActiveRide, 10000);
        return () => clearInterval(interval);
    }, []);

    if (rideInSearch) return <RideInSearch setRideInSearch={setRideInSearch} />;
    if (rideInProgress) return <RideInProgress setRideInProgress={setRideInProgress} order={order} />;
    if (loading) return <Loader />;

    return (
        <div className="order pageContent">
            <PageLabel text="Užsisakyti" />
            <OrderForm setRideInSearch={setRideInSearch} />
        </div>
    );
}

export default Order;